export default "__VITE_ASSET__512de5f0__"